import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Popup, Header, Title, Body, Footer } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { forwardRef } from 'react';
const blockCss = "b14jhrfn";
const Block = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(blockCss, props.className)} />;
});
export const ChooseMethodModal = ({
  onRoundRobin,
  onTeamMember,
  onClose
}) => <Popup isOpen onClose={onClose}>
    <Header>
      <Title>
        {I18n.t('publisher.dashboard.event.reschedule_event')}
      </Title>
    </Header>
    <Body>
      <Block>
        {I18n.t('publisher.dashboard.event.how_to_reschedule')}
      </Block>
      <Block>
        <Button wide onClick={onRoundRobin}>
          {I18n.t('publisher.dashboard.event.round_robin')}
        </Button>
      </Block>
      <Block>
        <Button wide onClick={onTeamMember}>
          {I18n.t('publisher.dashboard.event.choose_team_member')}
        </Button>
      </Block>
    </Body>
    <Footer>
      <Button wide decoration="secondary-outline" onClick={onClose}>
        {I18n.t('publisher.action.cancel')}
      </Button>
    </Footer>
  </Popup>;

require("./choose_method_modal.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./choose_method_modal.js");